import React, { useRef, useState, cloneElement } from 'react';
import classNames from 'classnames';
import { useThumbnailSize } from '../../../hooks/use-thumbnail-size.hook';

const GRID_ITEM_RATIO = 1.51;

export const GridItem = ({
    className = '',
    children = null,
    countColumnsCallback = null,
}) => {
    const thumbnailRef = useRef();
    const [minThumbnailHeight, setMinThumbnailHeight] = useState(0);

    // set relevant class name depending on size of element in the grid
    const { thumbnailSize } = useThumbnailSize(thumbnailRef, (width) => {
        setMinThumbnailHeight(width / GRID_ITEM_RATIO);

        if (countColumnsCallback) {
            countColumnsCallback(width);
        }
    });

    if (!children) {
        return null;
    }

    // pass thumbnail size name to children as new prop
    const childrenWithItemSize = React.Children.map(children, (child) =>
        cloneElement(child, { thumbnailSize })
    );

    const itemClassName = classNames(
        'casino-vertical-grid__item',
        `casino-vertical-grid__item--${thumbnailSize}`,
        {
            [className]: !!className,
        },
    );

    return <div
        ref={thumbnailRef}
        className={itemClassName}
        style={{
            // save grid item ratio if game image was not loaded
            minHeight: `${minThumbnailHeight}px`,
        }}
    >
        {childrenWithItemSize}
    </div>;
};
